<template>
  <v-row class="bbr-program--details-form">
    <v-col cols="12">
      <v-text-field
        hide-details
        v-model="form.name"
        label="Name"
        :error-messages="form.$getError('name')"
        outlined
        flat
      />
      <v-checkbox
        v-model="form.is_active"
        label="Active"
        hide-details
      ></v-checkbox>
      <v-text-field
        class="pt-5"
        width="8px"
        hide-details
        v-model="form.order"
        label="Order"
        :error-messages="form.$getError('order')"
        outlined
        flat
      />
      <v-text-field
        class="pt-5"
        hide-details
        v-model="form.icon"
        label="Category Tile Image"
        :error-messages="form.$getError('icon')"
        outlined
        flat
      />
    </v-col>
  </v-row>
</template>

<script>
import Form from '@/utils/form'

export default {
  name: 'MealGuideCategoryForm',

  props: {
    formData: {
      type: Form,
      required: true,
    },
  },

  components: {},

  data() {
    return {
      form: this.formData,
    }
  },

  watch: {
    formData() {
      this.form = this.formData
    },
  },

  computed: {},

  methods: {},
}
</script>
